import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Topics from "Data/Topics";
import { MathUtils } from "html-living-framework";

export class Horse extends SceneSpine {

	tracks = {
		BODY: 0,
		MOUTH: 1,
		HAIR: 2,
		PROPS: 3,
	}

	constructor() {
		super("holly-horse");
		this.spine.stateData.setMix('walk', 'trot', 0.5);
		this.spine.stateData.setMix('trot', 'walk', 0.5);
		this.spine.stateData.setMix('walk-stepped', 'trot-stepped', 0.5);
		this.spine.stateData.setMix('trot-stepped', 'walk-stepped', 0.5);
		this.spine.autoUpdate = true;
	}

	public Idle() {
		const entry = this.playAnimation(HLF.ArrayUtils.random(['idle-ear-flick', 'idle-stomp', 'idle-tail-whip']), false, this.tracks.BODY);
		if (entry) {
			entry.timeScale = 1.25;
		}
	}

	public SmallIdle() {
		const entry = this.playAnimation(HLF.ArrayUtils.random(['idle-ear-flick', 'idle-tail-whip']), false, this.tracks.BODY);
		if (entry) {
			entry.timeScale = 1.25;
		}
	}

	public SaddleOn() {
		this.playAnimation('saddle-on', false, this.tracks.PROPS);
	}

	public SaddleOff() {
		this.spine.state.clearTrack(this.tracks.PROPS);
	}

	public Chew() {
		const entry = this.playAnimation('chewing', true, this.tracks.MOUTH);
		if (entry) {
			entry.timeScale = 1.25;
		}
	}

	public StopChewing() {
		this.spine.state.clearTrack(this.tracks.MOUTH);
	}

	public BrushHair(pPercent: number) {
		const entry = this.playAnimation('hair-brush', true, this.tracks.HAIR);
		if (entry) {
			entry.timeScale = 0;
			entry.trackTime = MathUtils.lerp(entry.animationStart, entry.animationEnd, pPercent);
		}
	}

	public BrushTail(pPercent: number) {
		const entry = this.playAnimation('tail-brush', true, this.tracks.HAIR);
		if (entry) {
			entry.timeScale = 0;
			entry.trackTime = MathUtils.lerp(entry.animationStart, entry.animationEnd, pPercent);
		}
	}

	public Walk() {
		this.playAnimation('walk', true, this.tracks.BODY);
	}

	public Trot() {
		this.playAnimation('trot', true, this.tracks.BODY);
	}

	public StopWalking() {
		const entry = this.playAnimation('walk', true, this.tracks.BODY);
		entry!.timeScale = 0;
	}

	public StopBrushing() {
		this.spine.state.clearTrack(this.tracks.HAIR);
	}
}